import React from 'react'
import { Link } from 'react-router-dom'

function ServiceDetails() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{backgroundImage: 'url(/tm/react/roboto/assets/images/subheader.jpg)' }}>
    	<div className="container">
    		<div className="row">
    			<div className="col-12 text-center">
    				<h1 className="text-white page-title">Service Details</h1>
    			</div>
    		</div>
    	</div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Service Details Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="post_details service_details">
                        <div className="post_image">
                            <Link to="/service" className="d-flex h-100">
                                <img src="/tm/react/roboto/assets/images/service/details.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <h2 className="post_title"><Link to="/service">Machine Learning</Link></h2>
                        <div className="blog_meta">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                        </div>
                        <hr/>
                        <div className="post_navigation">
                            <Link to="/service" className="nav_item">Previous</Link>
                            <Link to="/service" className="nav_item">Next</Link>
                        </div>
                        
                        <div className="comment_box">
                            <h5>Reviews [2]</h5>
                            <ul className="comments">
                                <li className="comment">
                                    <article>
                                        <div className="comment_image">
                                            <img src="/tm/react/roboto/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                                        </div>
                                        <div className="comment_text">
                                            <h6 className="title">Anna Deo</h6>
                                            <div className="comment_date">10 Dec 2024</div>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                        </div>
                                    </article>
                                    <ul className="comments children">
                                        <li className="comment">
                                            <article>
                                                <div className="comment_image">
                                                    <img src="/tm/react/roboto/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                                                </div>
                                                <div className="comment_text">
                                                    <h6 className="title">Jhon Deo</h6>
                                                    <div className="comment_date">10 Dec 2024</div>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                                </div>
                                            </article>
                                        </li>
                                    </ul>
                                </li>
                                <li className="comment">
                                    <article>
                                        <div className="comment_image">
                                            <img src="/tm/react/roboto/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                                        </div>
                                        <div className="comment_text">
                                            <h6 className="title">Anna Wright</h6>
                                            <div className="comment_date">10 Dec 2024</div>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                        </div>
                                    </article>
                                </li>
                            </ul>
                        </div>
                        <div className="comment_form">
                            <h5>Leave A Reply</h5>
                            <form className="form_style style_two">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input type="text" name="#" placeholder="Your Full Name" className="form-control form-control-custom" autoComplete="off"/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <input type="email" name="#" placeholder="Your Email" className="form-control form-control-custom" autoComplete="off"/>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <textarea rows="5" name="#" placeholder="Write Message" className="form-control form-control-custom" autoComplete="off"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <button type="submit" className="thm-btn btn-rounded w-100">
                                            <span className="button_title">Leave Comment</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    </div>
  )
}

export default ServiceDetails